import { render, staticRenderFns } from "./recallNoticeAction.vue?vue&type=template&id=5ef3291e&scoped=true"
import script from "./recallNoticeAction.vue?vue&type=script&lang=js"
export * from "./recallNoticeAction.vue?vue&type=script&lang=js"
import style0 from "./recallNoticeAction.vue?vue&type=style&index=0&id=5ef3291e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef3291e",
  null
  
)

export default component.exports